import { useState } from 'react';
import ProductPrice from '../ProductPrice/ProductPrice';
import { ProductCardItem } from '../../types/api';
import { Link } from 'react-router-dom';
import AddToCartControl from '../AddToCartControl/AddToCartControl';
import WishlistButton from '../WishlistButton/WishlistButton';
import NotifyMeButton from '../NotifyMe/NotifyMeButton';
import './ProductCard.css';

interface ProductCardProps {
  result: ProductCardItem;
}

export default function ProductCard({ result }: ProductCardProps) {
  const [failedThumbnail, setFailedThumbnail] = useState<string | null>(null);
  const soldOut = result.in_stock === false;
  const thumbnail =
    result.thumbnail_url && failedThumbnail !== result.thumbnail_url ? result.thumbnail_url : null;

  return (
    <li className={`product-card${soldOut ? ' product-card--sold-out' : ''}`}>
      <Link
        to={`/products/${result.item_id}`}
        className="product-card__link"
        aria-label={`View details for ${result.display_name || result.description}`}
      >
        <div className="product-card__image-wrap">
          {soldOut && <span className="product-card__badge">Sold out</span>}
          <img
            className="product-card__image"
            src={thumbnail || result.image_url}
            srcSet={
              thumbnail && result.thumbnail_url_2x
                ? `${thumbnail} 1x, ${result.thumbnail_url_2x} 2x`
                : undefined
            }
            onError={() => {
              if (thumbnail) setFailedThumbnail(thumbnail);
            }}
            decoding="async"
            alt={result.description}
            loading="lazy"
          />
        </div>
        <div className="product-card__copy">
          <p className="product-card__description">{result.description}</p>
        </div>
      </Link>
      <p className="product-card__price">
        <ProductPrice pricing={result.pricing} price={result.price} />
      </p>
      <WishlistButton
        itemId={result.item_id}
        name={result.display_name || result.description}
        className="product-card__wish"
      />
      <AddToCartControl
        product={result}
        soldOut={soldOut}
        soldOutAction={
          <NotifyMeButton
            itemId={result.item_id}
            name={result.display_name || result.description}
            className="product-card__button"
          />
        }
        buttonClassName="product-card__button"
        stepperClassName="product-card__stepper"
      />
    </li>
  );
}
